import { Link } from 'react-router-dom';
import Reveal from '@/pages/zz-review/components/Reveal';

export default function FinalCtaSection() {
  return (
    <section id="cta" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <p
            className="text-xl md:text-2xl text-foreground-900 mb-4"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            從《1001旋轉門》開始，走進整棵生命樹。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto mb-8">
            現在最清楚、最成熟、最容易進入的起點，就是《1001旋轉門》。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
            <Link
              to="/revolving-gate"
              className="whitespace-nowrap px-8 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer"
            >
              進入《1001旋轉門》
            </Link>
            <a
              href="mailto:service@aum1001matrix.org"
              className="whitespace-nowrap px-8 py-3 rounded-md border border-foreground-200 text-foreground-700 text-sm md:text-base hover:bg-foreground-50 transition-colors cursor-pointer"
            >
              聯絡我們
            </a>
          </div>
          <p className="text-xs text-foreground-400">aum1001matrix.org</p>
        </Reveal>
      </div>
    </section>
  );
}